<template>
  <v-list-group>
    <template #activator>
      <v-list-item-title class="primary--text text-body-1 item-list">
        <v-icon color="primary">mdi-web</v-icon>
        <span class="ml-2">
          {{ idiom.name }}
        </span>
      </v-list-item-title>
    </template>
    <template #appendIcon>
      <v-icon color="primary">mdi-chevron-down</v-icon>
    </template>
    <v-list-item v-for="i in items" :key="i.index" ripple class="pl-5">
      <v-list-item-title
        class="primary--text text-body-2"
        @click="handleLocale(i)"
      >
        {{ i.title }}
      </v-list-item-title>
    </v-list-item>
  </v-list-group>
</template>

<script>
// import SubMenu from '@/components/commons/SubMenu'
import { mapState, mapActions } from 'vuex'
export default {
  name: 'LanguageMenuDrawer',
  // components: { SubMenu },
  computed: {
    ...mapState('language', ['languages', 'idiom']),
    items() {
      return this.languages
        .filter(item => item.code !== this.idiom.code)
        .map(item => {
          return {
            ...item,
            title: item.name
          }
        })
    }
  },
  methods: {
    ...mapActions('language', ['setIdiom']),
    ...mapActions(['setLoading']),
    handleLocale(item) {
      this.setLoading(true)
      try {
        /*
        this.$i18n.locale = item.code
        this.$i18n.setLocaleMessage(item.code, item.translations)
        */
        this.setIdiom(item)
      } catch (error) {
        console.log(error)
      } finally {
        this.setLoading(false)
      }
    }
  },
  created() {
    this.setIdiom(this.idiom)
  }
}
</script>

<style scoped>
.v-list-item__title {
  color: #686f8d;
}

.margin-logo {
  margin-left: 35px;
  padding: 0;
}

.margin-list {
  padding: 0;
}

.margin-list a {
  padding-left: 47px;
  font-weight: bold;
}

.item-list {
  padding-left: 0;
}

.navbutton {
  text-transform: none !important;
  font-weight: bold;
}

.bottom_list {
  margin-left: -3.5px;
}
.bottom_list:last-child {
  margin-left: 1.5px;
}

.list_color {
  color: #686f8d !important;
  font-weight: bold;
}

.init {
  margin-left: 2px;
}
</style>
